import { CreateRetailSettingsDto } from "./../../../dtos/catalogs/RetailSettings/CreateRetailSettingsDto";
import { TaxGroupService } from "./../../../services/catalogs/TaxGroupService";
import { CreateTaxGroupDto } from "../../../dtos/catalogs/taxGroup/CreateTaxGroupDto";
import React from "react";
import { TaxGroupDetail } from "../../../components/Pages/Catalogs/Tax Group/TaxGroupDetail";

import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupTaxGroup } from "../../../components/Shared/NewForms/NFLookupTaxGroup";
import TaxGroupList from "../../../components/Pages/Catalogs/Tax Group/TaxGroupList";
import { RetailSettingsDetail } from "../../../components/Pages/Catalogs/RetailSettings/RetailSettingsDetail";
import RetailSettingsList from "../../../components/Pages/Catalogs/RetailSettings/RetailSettingsList";
import { NFLookupRetailSettings } from "../../../components/Shared/NewForms/NFLookupRetailSettings";

export const RetailSettings: IAppEntity = {
  entityType: "catalog",
  title: "Retail Setting",
  pluralTitle: "Retail Setting",
  apiUrl: "RetailSettings",
  apiEnum: ReferenceTypes.CatalogRetailSetting,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(RetailSettingsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(RetailSettingsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupRetailSettings, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new TaxGroupService(this.apiUrl);
  },
  getEmptyModel(): CreateRetailSettingsDto {
    return {
      name: "",
      posTerminals: [],
      createdDate: new Date(),
    };
  },
};
